<template>
    <div class="d-flex justify-content-center align-items-center mt-4">
        <div class="d-flex flex-column org-settings-card p-4 col-12 col-sm-10 col-md-7 col-lg-5 col-xl-3"
             :class="loading ? 'justify-content-center' : ''">
            <ProgressSpinner v-if="loading" class="progress-spinner"/>
            <div v-else>
                <div class="d-flex flex-column kt-font-lg my-3 px-3">
                    <div class="d-flex flex-column align-items-start mt-2">
                        <div class="w-100">
                            <div>
                                {{ $t('AppOrganizationSettingsCard.Fusos horários') }}
                            </div>
                            <div class="mt-1">
                                <Dropdown v-model="selectedTimezone" :options="TIMEZONES" filter class="w-100"
                                          :placeholder="$t('AppOrganizationSettingsCard.Selecione o fuso')"/>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex mt-3 kt-font-md">
                        <div class="d-flex flex-column col-5 pl-0">
                            <div class="font-weight-bold mb-1">
                                {{ $t('AppOrganizationSettingsCard.Horário UTC') }}
                            </div>
                            <div>
                                {{ dateHourFormat(currentTime, 'UTC') }}
                            </div>
                        </div>
                        <div class="d-flex flex-column col-7">
                            <div class="font-weight-bold mb-1">
                                {{ !selectedTimezone ? $t('AppOrganizationSettingsCard.Selecione um fuso para verificar seu horário') : selectedTimezone }}
                            </div>
                            <div v-if="selectedTimezone">
                                {{ dateHourFormat(currentTime, selectedTimezone) }}
                            </div>
                        </div>
                    </div>
                    <div class="card-divider my-4"></div>
                    <div class="d-flex flex-column align-items-start">
                        <div>
                            <div>
                                {{ $t('AppOrganizationSettingsCard.Formato de horas') }}
                            </div>
                            <div class="mt-1">
                                <SelectButton v-model="selectedHourFormat" :options="hourFormatOptions"
                                              optionLabel="name" optionValue="value" :unselectable="false"/>
                            </div>
                            <div class="mt-2 kt-font-md text-muted">
                                {{ $t('AppOrganizationSettingsCard.Exemplo') }}: {{ hourFormatExample }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="d-flex justify-content-end mt-4">
                    <Button :label="$t('AppOrganizationSettingsCard.Salvar')" @click="updateOrganization"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import dateHourFormat from '../../../mixins/DateMixin';
import InputText from 'primevue/inputtext'
import Dropdown from 'primevue/dropdown';
import Button from 'primevue/button';
import moment from 'moment';
import ProgressSpinner from "primevue/progressspinner";
import SelectButton from 'primevue/selectbutton';
import {DEFAULT_HOUR_FORMAT, formatHours, HOUR_FORMATS} from "@/utils/hourFormat";

export default {
    mixins: [dateHourFormat],
    mounted() {
        this.interval = setInterval(this.updateCurrentTime, 1000);
        this.TIMEZONES = moment.tz.names();
        this.setData();
    },
    beforeDestroy() {
        clearInterval(this.interval);
    },
    data() {
        return {
            TIMEZONES: [],
            selectedTimezone: null,
            selectedHourFormat: DEFAULT_HOUR_FORMAT,
            hourFormatOptions: [
                {name: this.$t('AppOrganizationSettingsCard.Horas e minutos'), value: HOUR_FORMATS.HOURS_MINUTES},
                {name: this.$t('AppOrganizationSettingsCard.Horas decimais'), value: HOUR_FORMATS.DECIMAL}
            ],
            HOUR_FORMAT_EXAMPLE_VALUE: 2.5667,
            interval: null,
            currentTime: null
        }
    },
    props: {
        organization: {
            type: Object,
            required: true
        },
        gettingData: {
            type: Boolean
        }
    },
    methods: {
        setData() {
            this.selectedTimezone = this.organization.zone_offset
            this.selectedHourFormat = this.organization.hour_format || DEFAULT_HOUR_FORMAT
        },
        updateCurrentTime() {
            this.currentTime = parseInt(Date.now() / 1000)
        },
        updateOrganization() {
            if(this.currentValues){
                this.$toast.add({
                    severity: 'warn',
                    summary: this.$t('AppOrganizationSettings.O formulário não possui alterações!'),
                    life: 5000
                });
                return
            }

            if (!this.selectedTimezone) {
                this.$toast.add({
                    severity: 'warn',
                    summary: this.$t('AppOrganizationSettingsCard.Selecione o fuso horário da organização para salvar'),
                    life: 5000
                });
                return
            }

            this.$emit('save',{timezone: this.selectedTimezone, hourFormat: this.selectedHourFormat})
        }
    },
    watch: {
        organization: function() {
            this.setData();
        }
    },
    computed: {
        loading: function () {
            return !this.currentTime || this.gettingData;
        },
        currentValues: function () {
            return this.organization.zone_offset === this.selectedTimezone &&
                (this.organization.hour_format || DEFAULT_HOUR_FORMAT) === this.selectedHourFormat
        },
        hourFormatExample: function () {
            return formatHours(this.HOUR_FORMAT_EXAMPLE_VALUE, {format: this.selectedHourFormat});
        }
    },
    components: {
        ProgressSpinner, Button, Dropdown, InputText, SelectButton
    }
}
</script>

<style scoped>
.org-settings-card {
    background: white;
    border-radius: 1rem;
}

.card-divider {
    border-bottom: lightgrey 1px dashed;
    width: 100%;
}

.progress-spinner {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 4rem;
}
</style>
